<template>
  <ResponsiveModal
    theme="success"
    :title="title"
    :description="description"
    :cancelLabel="cancelLabel || $t('components.buttons.cancel')"
    :confirmLabel="confirmLabel || $t('components.buttons.complete')"
    :alignButtons="maxSmall ? 'center' : 'end'"
    @confirm="$emit('click', 'completed')"
  >
    <slot />
    <template #content>
      <div class="flex flex-col items-center p-4">
        <span v-if="maxSmall">
          {{ description }}
        </span>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["click"]);

defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  cancelLabel: { type: String, required: false },
  confirmLabel: { type: String, required: false },
});
</script>
